import { render, staticRenderFns } from "./PInfo.vue?vue&type=template&id=0096df79&scoped=true&"
import script from "./PInfo.vue?vue&type=script&lang=js&"
export * from "./PInfo.vue?vue&type=script&lang=js&"
import style0 from "./PInfo.vue?vue&type=style&index=0&id=0096df79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096df79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
